import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

// Import the custom theme
import theme from './theme';

// Pages
import Login from './pages/Login';
import Signup from './pages/Signup';
import Dashboard from './pages/Dashboard';
import Projects from './pages/Projects';
import PullRequestList from './pages/PullRequestList';
import AzurePRDetails from './pages/AzurePRDetails';
import GitHubPRDetails from './pages/GitHubPRDetails';
import BitbucketPRDetails from './pages/BitbucketPRDetails';
import GitLabMRDetails from './pages/GitLabMRDetails';
import Settings from './pages/Settings';
import SecurityLog from './pages/SecurityLog';
import OAuthCallback from './pages/OAuthCallback';
import CompleteProfile from './pages/CompleteProfile';
import PRAnalysis from './pages/PRAnalysis';
import JiraAnalysis from './pages/JiraAnalysis';
import AzureBoardsAnalysis from './pages/AzureBoardsAnalysis';
import TrelloAnalysis from './pages/TrelloAnalysis';
import LandingPage from './pages/LandingPage';
import Setup from './pages/Setup';
import Contact from './pages/Contact';
import ProfileSettings from './pages/ProfileSettings';
import ManageSubscription from './pages/ManageSubscription';
import ProjectSelection from './pages/ProjectSelection';
import CompliancePolicy from './pages/CompliancePolicy';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfUse from './pages/TermsOfUse';
import CookiePolicy from './pages/CookiePolicy';
import ServiceLevelAgreement from './pages/ServiceLevelAgreement';
import Support from './pages/Support';
import WhatWeDo from './pages/WhatWeDo';
import Blog from './pages/Blog';
import AuthAction from './pages/AuthAction';

// Components
import Layout from './components/Layout';
import PublicLayout from './components/PublicLayout';
import { PlansSection } from './components/subscription';
import CookieBanner from './components/CookieBanner';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/auth/callback/:provider" element={<OAuthCallback />} />
        <Route path="/complete-profile" element={<CompleteProfile />} />
        <Route path="/dashboard" element={<Navigate to="/app/dashboard" replace />} />
        <Route path="/projects" element={<Navigate to="/app/projects" replace />} />

        {/* Public marketing pages — share a single persistent Navigation instance */}
        <Route element={<PublicLayout />}>
          <Route path="/" element={<LandingPage />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/setup" element={<Setup />} />
          <Route path="/what-we-do" element={<WhatWeDo />} />
          <Route path="/blog" element={<Blog />} />
        </Route>

        <Route path="/compliance-policy" element={<CompliancePolicy />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-use" element={<TermsOfUse />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="/service-level-agreement" element={<ServiceLevelAgreement />} />
        <Route path="/support" element={<Support />} />
        <Route path="/auth/action" element={<AuthAction />} />
        <Route path="/app" element={<Layout />}>
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="projects" element={<Projects />} />
          <Route path="pull-requests" element={<PullRequestList />} />
          <Route path="pull-requests/:organization/:project/:repositoryID/:prNumber/details" element={<AzurePRDetails />} />
          <Route path="pull-requests/github/:owner/:repo/:prNumber/details" element={<GitHubPRDetails />} />
          <Route path="pull-requests/bitbucket/:workspace/:repoSlug/:prNumber/details" element={<BitbucketPRDetails />} />
          <Route path="pull-requests/:ownerAndRepo/:prNumber/details" element={<GitHubPRDetails />} />
          <Route path="pull-requests/gitlab/:projectID/:mrNumber/details" element={<GitLabMRDetails />} />
          <Route path="pr-analysis" element={<PRAnalysis />} />
          <Route path="jira-analysis" element={<JiraAnalysis />} />
          <Route path="azure-boards-analysis" element={<AzureBoardsAnalysis />} />
          <Route path="trello-analysis" element={<TrelloAnalysis />} />
          <Route path="settings" element={<Settings />} />
          <Route path="security" element={<SecurityLog />} />
          <Route path="profile-settings" element={<ProfileSettings />} />
          <Route path="manage-subscription" element={<ManageSubscription />} />
          <Route path="project-selection" element={<ProjectSelection />} />
        </Route>
        <Route path="/plans" element={<PlansSection />} />
      </Routes>
      <CookieBanner />
    </ThemeProvider>
  );
}

export default App; 